import m from "@babel/runtime/helpers/esm/objectSpread2";
import z from "@babel/runtime/helpers/esm/extends";
import M from "@babel/runtime/helpers/esm/typeof";
import I from "@babel/runtime/helpers/esm/toConsumableArray";
import G from "@babel/runtime/helpers/esm/objectWithoutProperties";
import E from "@babel/runtime/helpers/esm/slicedToArray";
import R from "@babel/runtime/helpers/esm/classCallCheck";
import A from "@babel/runtime/helpers/esm/createClass";
import x from "@babel/runtime/helpers/esm/assertThisInitialized";
import H from "@babel/runtime/helpers/esm/inherits";
import N from "@babel/runtime/helpers/esm/createSuper";
import d from "@babel/runtime/helpers/esm/defineProperty";
import { sstyled as $ } from "@semcore/utils/lib/core/index";
import L, { Component as j, sstyled as D, assignProps as S } from "@semcore/core";
import s from "react";
import v, { isInputTriggerTag as Z } from "@semcore/popper";
import P from "@semcore/utils/lib/capitalizeFirstLetter";
import F, { useUID as k } from "@semcore/utils/lib/uniqueID";
import U from "@semcore/utils/lib/enhances/i18nEnhance";
import { localizedMessages as C } from "./translations/__intergalactic-dynamic-locales.mjs";
import { hasFocusableIn as W } from "@semcore/utils/lib/use/useFocusLock";
import { DropdownItem as J } from "./DropdownItem.mjs";
import { Box as K, Flex as T } from "@semcore/flex-box";
var X = ["Children", "forwardRef", "modifiers", "stretch"], B = (
  /*__reshadow_css_start__*/
  ($.insert(
    /*__inner_css_start__*/
    '.___SDropdownPopper_grsey_gg_{position:relative;background-color:var(--intergalactic-bg-primary-neutral, #ffffff);border-radius:var(--intergalactic-popper-rounded, 6px);box-sizing:border-box;border:1px solid var(--intergalactic-border-secondary, #e0e1e9);white-space:normal;box-shadow:var(--intergalactic-box-shadow-popper, 0px 1px 12px 0px rgba(25, 27, 35, 0.15));color:var(--intergalactic-text-primary, #191b23)}.___SDropdownPopper_grsey_gg_ .___SDropdownItem_grsey_gg_{position:relative;-webkit-text-decoration:none;text-decoration:none;box-sizing:border-box;cursor:pointer;width:100%;text-align:left;line-height:normal;color:var(--intergalactic-text-primary, #191b23)}@media (hover:hover){.___SDropdownPopper_grsey_gg_ .___SDropdownItem_grsey_gg_:hover{background-color:var(--intergalactic-dropdown-menu-item-hover, #f4f5f9)}}.___SDropdownPopper_grsey_gg_ .___SDropdownItem_grsey_gg_:focus{outline:0}.___SDropdownPopper_grsey_gg_ .___SDropdownItem_grsey_gg_.__isMenuItemCheckbox_grsey_gg_.__selected_grsey_gg_::after,.___SDropdownPopper_grsey_gg_ .___SDropdownItem_grsey_gg_.__isMenuItemCheckbox_grsey_gg_::before{content:"";position:absolute;border:1px solid;border-radius:var(--intergalactic-addon-rounded, 4px);box-sizing:content-box}.___SDropdownPopper_grsey_gg_ .___SDropdownItem_grsey_gg_.__isMenuItemCheckbox_grsey_gg_::before{display:inline-block;background:var(--intergalactic-bg-primary-neutral, #ffffff);transition:calc(var(--intergalactic-duration-control, 200)*1ms) all ease-in-out;border-color:var(--intergalactic-border-primary, #c4c7cf)}.___SDropdownPopper_grsey_gg_ .___SDropdownItem_grsey_gg_.__isMenuItemCheckbox_grsey_gg_.__selected_grsey_gg_::after{background-repeat:no-repeat;background-position:center center;background-color:var(--intergalactic-control-primary-info, #008ff8);border-color:var(--intergalactic-control-primary-info, #008ff8);background-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iNyIgdmlld0JveD0iMCAwIDEwIDciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik04LjI1IDFMNCA1LjI1TDEuNzUgMyIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==)}.___SDropdownPopper_grsey_gg_ .___SDropdownItem_grsey_gg_.__selected_grsey_gg_:not(.___SDropdownItem_grsey_gg_.__isMenuItemCheckbox_grsey_gg_){background-color:var(--intergalactic-dropdown-menu-item-selected, rgba(196, 229, 254, 0.7));box-shadow:2px 0 0 0 var(--intergalactic-control-primary-info, #008ff8) inset}@media (hover:hover){.___SDropdownPopper_grsey_gg_ .___SDropdownItem_grsey_gg_.__selected_grsey_gg_:not(.___SDropdownItem_grsey_gg_.__isMenuItemCheckbox_grsey_gg_):hover{background-color:var(--intergalactic-dropdown-menu-item-selected-hover, #c4e5fe)}}.___SDropdownPopper_grsey_gg_ .___SDropdownItem_grsey_gg_.__highlighted_grsey_gg_.__isMenuItemCheckbox_grsey_gg_:not(button),.___SDropdownPopper_grsey_gg_ .___SDropdownItem_grsey_gg_.__highlighted_grsey_gg_:not(.___SDropdownItem_grsey_gg_.__isMenuItemCheckbox_grsey_gg_):not(button){z-index:1;box-shadow:var(--intergalactic-keyboard-focus, 0px 0px 0px 3px rgba(0, 143, 248, 0.5)) inset}.___SDropdownPopper_grsey_gg_ .___SDropdownItem_grsey_gg_.__disabled_grsey_gg_{opacity:var(--intergalactic-disabled-opacity, 0.3);cursor:default;pointer-events:none}.___SDropdownPopper_grsey_gg_ .___SDropdownItem_grsey_gg_._size_l_grsey_gg_{font-size:var(--intergalactic-fs-300, 16px);line-height:var(--intergalactic-lh-300, 150%);padding:var(--intergalactic-spacing-2x, 8px) var(--intergalactic-spacing-3x, 12px);min-height:40px}.___SDropdownPopper_grsey_gg_ .___SDropdownItem_grsey_gg_._size_l_grsey_gg_.__isMenuItemCheckbox_grsey_gg_{padding-left:calc(var(--intergalactic-spacing-3x, 12px)*2 + 16px + 2px)}.___SDropdownPopper_grsey_gg_ .___SDropdownItem_grsey_gg_._size_l_grsey_gg_.__isMenuItemCheckbox_grsey_gg_::after,.___SDropdownPopper_grsey_gg_ .___SDropdownItem_grsey_gg_._size_l_grsey_gg_.__isMenuItemCheckbox_grsey_gg_::before{width:20px;height:20px;top:calc(var(--intergalactic-spacing-2x, 8px) - 1px);left:var(--intergalactic-spacing-3x, 12px)}.___SDropdownPopper_grsey_gg_ .___SDropdownItem_grsey_gg_._size_m_grsey_gg_{font-size:var(--intergalactic-fs-200, 14px);line-height:var(--intergalactic-lh-200, 142%);padding:calc(var(--intergalactic-spacing-1x, 4px) + var(--intergalactic-spacing-05x, 2px)) var(--intergalactic-spacing-2x, 8px);min-height:32px}.___SDropdownPopper_grsey_gg_ .___SDropdownItem_grsey_gg_._size_m_grsey_gg_.__isMenuItemCheckbox_grsey_gg_{padding-left:calc(var(--intergalactic-spacing-2x, 8px)*2 + 16px + 2px)}.___SDropdownPopper_grsey_gg_ .___SDropdownItem_grsey_gg_._size_m_grsey_gg_.__isMenuItemCheckbox_grsey_gg_::after,.___SDropdownPopper_grsey_gg_ .___SDropdownItem_grsey_gg_._size_m_grsey_gg_.__isMenuItemCheckbox_grsey_gg_::before{width:16px;height:16px;top:calc(var(--intergalactic-spacing-2x, 8px) - 1px);left:var(--intergalactic-spacing-2x, 8px)}.___SDropdownPopper_grsey_gg_ .___SDropdownItem_grsey_gg_.__notInteractive_grsey_gg_{cursor:default}@media (hover:hover){.___SDropdownPopper_grsey_gg_ .___SDropdownItem_grsey_gg_.__notInteractive_grsey_gg_:hover{background:0 0}}.___SDropdownPopper_grsey_gg_ .___SDropdownItem_grsey_gg_._variant_hint_grsey_gg_{color:var(--intergalactic-text-secondary, #6c6e79);cursor:default}@media (hover:hover){.___SDropdownPopper_grsey_gg_ .___SDropdownItem_grsey_gg_._variant_hint_grsey_gg_:hover{background:0 0}}.___SDropdownPopper_grsey_gg_ .___SDropdownItem_grsey_gg_._variant_title_grsey_gg_{font-weight:var(--intergalactic-bold, 700);cursor:default}@media (hover:hover){.___SDropdownPopper_grsey_gg_ .___SDropdownItem_grsey_gg_._variant_title_grsey_gg_:hover{background:0 0}}.___SDropdownPopper_grsey_gg_ .___SDropdownItem_grsey_gg_.__visible_grsey_gg_{background-color:var(--intergalactic-dropdown-menu-item-hover, #f4f5f9)}.___SDropdownPopper_grsey_gg_ .___SDropdownItem_grsey_gg_.__nesting-trigger_grsey_gg_{justify-content:space-between}.___SDropdownPopper_grsey_gg_ .___SGroupTitle_grsey_gg_{font-weight:var(--intergalactic-bold, 700)}.___SDropdownPopper_grsey_gg_ .___SGroupHint_grsey_gg_{color:var(--intergalactic-text-secondary, #6c6e79)}',
    "grsey_gg_"
  ), {
    __SDropdownPopper: "___SDropdownPopper_grsey_gg_",
    __SDropdownItem: "___SDropdownItem_grsey_gg_",
    _isMenuItemCheckbox: "__isMenuItemCheckbox_grsey_gg_",
    _selected: "__selected_grsey_gg_",
    _highlighted: "__highlighted_grsey_gg_",
    _disabled: "__disabled_grsey_gg_",
    _size_l: "_size_l_grsey_gg_",
    _size_m: "_size_m_grsey_gg_",
    _notInteractive: "__notInteractive_grsey_gg_",
    _variant_hint: "_variant_hint_grsey_gg_",
    _variant_title: "_variant_title_grsey_gg_",
    _visible: "__visible_grsey_gg_",
    "_nesting-trigger": "__nesting-trigger_grsey_gg_",
    __SGroupTitle: "___SGroupTitle_grsey_gg_",
    __SGroupHint: "___SGroupHint_grsey_gg_"
  })
), O = ["INPUT", "TEXTAREA"], y = /* @__PURE__ */ function(a) {
  H(r, a);
  var c = N(r);
  function r() {
    var _;
    R(this, r);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return _ = c.call.apply(c, [this].concat(i)), d(x(_), "popperRef", /* @__PURE__ */ s.createRef()), d(x(_), "defaultModifiers", [{
      name: "flip",
      enabled: !1
    }, {
      name: "stretch",
      phase: "beforeRead",
      enabled: !0,
      fn: function(n) {
        var g = n.state, p = n.options, l = g.placement.split("-"), u = E(l, 1), f = u[0], b = ["left", "right"].indexOf(f) !== -1, w = b ? "height" : "width", h = g.elements.reference["offset".concat(P(w))];
        p.stretch === "min" && (g.rects.popper.width = Math.max(g.rects.popper.width, h), g.elements.popper.style["min".concat(P(w))] = "".concat(h, "px")), p.stretch === "fixed" && (g.rects.popper.width = h, g.elements.popper.style[w] = "".concat(h, "px"));
      }
    }]), d(x(_), "handlerTriggerKeyDown", function(t) {
      var n = _.asProps, g = n.visible, p = n.interaction, l = _.popperRef.current;
      if (p === "click" && g && t.key === "Tab" && l && !W(l)) {
        t.preventDefault();
        return;
      }
      t.key === " " && O.includes(t.target.tagName) || t.key === "Enter" && t.target.tagName === "TEXTAREA" || ["Enter", " "].includes(t.key) && p !== "none" && (t.preventDefault(), _.handlers.visible(!0));
    }), _;
  }
  return A(r, [{
    key: "uncontrolledProps",
    value: function() {
      return {
        visible: null
      };
    }
  }, {
    key: "getTriggerProps",
    value: function() {
      var e = this.asProps, i = e.uid, o = e.visible, t = e.disablePortal, n = e.getI18nText;
      return {
        id: "igc-".concat(i, "-trigger"),
        "aria-controls": o ? "igc-".concat(i, "-popper") : void 0,
        focusHint: o && !t ? n("triggerHint") : void 0,
        "aria-expanded": o ? "true" : "false",
        onKeyDown: this.handlerTriggerKeyDown,
        "aria-haspopup": "dialog"
      };
    }
  }, {
    key: "getPopperProps",
    value: function() {
      var e = this.asProps, i = e.uid, o = e.disablePortal, t = e.ignorePortalsStacking, n = e.interaction;
      return {
        id: "igc-".concat(i, "-popper"),
        tabIndex: 0,
        role: "dialog",
        disablePortal: o,
        ignorePortalsStacking: t,
        ref: this.popperRef,
        focusMaster: n === "click",
        autoFocus: "enforced"
      };
    }
  }, {
    key: "render",
    value: function() {
      var e = this.asProps, i = e.Children, o = e.forwardRef, t = e.modifiers, n = t === void 0 ? [] : t, g = e.stretch, p = G(e, X);
      return /* @__PURE__ */ s.createElement(v, z({
        ref: o,
        modifiers: [].concat(I(this.defaultModifiers), [{
          name: "stretch",
          options: M(g) === "object" ? g : {
            stretch: g
          }
        }], I(n))
      }, p), /* @__PURE__ */ s.createElement(i, null));
    }
  }]), r;
}(j);
d(y, "displayName", "Dropdown");
d(y, "style", B);
d(y, "defaultProps", {
  // timeout: [100, 50],
  placement: "bottom-start",
  offset: [0, 4],
  stretch: "min",
  defaultVisible: !1,
  i18n: C,
  locale: "en",
  interaction: "click"
});
d(y, "enhance", [F(), U(C)]);
function Q(a) {
  var c = arguments[0], r, _ = a.styles, e = a.tag, i = Z(e), o = v.Trigger;
  return r = D(_), /* @__PURE__ */ s.createElement(o, r.cn("SDropdownTrigger", m({}, S({
    role: i ? "combobox" : "button"
  }, c))));
}
function V(a) {
  var c = arguments[0], r, _ = a.styles, e = v.Popper;
  return r = D(_), /* @__PURE__ */ s.createElement(e, r.cn("SDropdownPopper", m({}, S({}, c))));
}
function q(a) {
  var c = arguments[0], r, _ = a.styles, e = a.title, i = a.Children, o = a.subTitle, t = a.size, n = K, g = Y.Item, p = T, l = T, u = k("title_mi_group"), f = k("sub_title_mi_group"), b = {
    "aria-labelledby": u,
    "aria-describedby": o ? f : void 0
  };
  return r = D(_), /* @__PURE__ */ s.createElement(s.Fragment, null, /* @__PURE__ */ s.createElement(g, r.cn("SDropdownItemContainer", {
    notInteractive: !0,
    "aria-hidden": "true",
    tabindex: -1,
    size: t
  }), /* @__PURE__ */ s.createElement(p, r.cn("SGroupTitle", {
    id: u
  }), e), o && /* @__PURE__ */ s.createElement(l, r.cn("SGroupHint", {
    id: f
  }), o)), /* @__PURE__ */ s.createElement(n, r.cn("SGroup", m({}, S(m(m({
    role: "group"
  }, b), {}, {
    __excludeProps: ["title"]
  }), c))), /* @__PURE__ */ s.createElement(i, r.cn("Children", {}))));
}
var Y = L(y, {
  Trigger: Q,
  Popper: V,
  Item: J,
  Group: q
}, {
  parent: v
});
export {
  Y as default
};
